import { Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../services/general.service';
import { GroupService } from '../../services/group.service';
import { ProvidersService } from '../../services/providers.service';
import {CostCenterDetailComponent} from '../cost-center-detail/cost-center-detail.component';

import * as decode from 'jwt-decode';
import { ModalConfirmComponent } from 'app/modal-confirm/modal-confirm.component';

@Component({
  selector: 'app-cost-center',
  templateUrl: './cost-center.component.html',
  styleUrls: ['./cost-center.component.scss']
})
export class CostCenterComponent implements OnInit {
  userId: any;
  userToken: any;
  temp = [];
  load = true;
  data: any = {};
  loadBtn = true;
  listCostCenter: any = [];
  listSocieties = [];
  listApprovers: any = [];
  listUsersPortal: any = [];
  EsCentroDeCosto = false;

  constructor(private router: Router, private toastr: ToastrService, public dialog: MatDialog, private gralService: GeneralService, private groupService: GroupService, private provService: ProvidersService) {
    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    const d = this.userToken.split('Bearer ');
    const tokenPayload = decode(d[1]);

    this.userId = tokenPayload.Id;

    if(router.url == '/admin/centro-costos'){
      gralService.changeTextHead('AUTHCENTERCOST');
      this.EsCentroDeCosto = true;
      this.getCostCenter();
    }else{
      gralService.changeTextHead('AUTHORDERINTERN');
      this.getInternOrder();
    }


  }

  ngOnInit() {
  }

  getInternOrder(){
    this.provService.getCostCenterIntern(this.userToken).then((data) => {
      this.listSocieties = data['lsSociedad'];
      this.listCostCenter = data['lsClaves'];
      this.listApprovers = data['lsAprobadores'];
    }, (err) => {
      console.log(err);
      //this.listCostCenter = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  getCostCenter(){
    this.provService.getCostCenter(this.userToken).then((data) => {
      this.listSocieties = data['lsSociedad'];
      this.listCostCenter = data['lsClaves'];
      this.listApprovers = data['lsAprobadores'];
    }, (err) => {
      console.log(err);
      //this.listCostCenter = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  new(){
    const dialogRef = this.dialog.open(CostCenterDetailComponent, {
      minWidth: '50%',
      position: {
        top: '6%'
      },
      data: { type: 'new', userId: this.userId, userToken: this.userToken, listSocieties: this.listSocieties, EsCentroDeCosto: this.EsCentroDeCosto }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        console.log(result);
        if(result.lsClaves){
          this.listCostCenter = result.lsClaves;
        }
      }
    });
  }

  detail(idx){
    const dialogRef = this.dialog.open(CostCenterDetailComponent, {
      minWidth: '70%',
      position: {
        top: '6%'
      },
      data: { type: 'users', userId: this.userId, userToken: this.userToken, listApprovers: this.listApprovers, EsCentroDeCosto: this.EsCentroDeCosto, info: this.listCostCenter[idx] }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        console.log(result);
        if(result.lsClaves){
          this.listCostCenter = result.lsClaves;
        }
      }
    });
  }

  assign(idx){
    const dialogRef = this.dialog.open(CostCenterDetailComponent, {
      minWidth: '50%',
      position: {
        top: '6%'
      },
      data: { type: 'assign', userId: this.userId, userToken: this.userToken, listApprovers: this.listApprovers, EsCentroDeCosto: this.EsCentroDeCosto, info: this.listCostCenter[idx] }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        console.log(result);
        if(result.lsClaves){
          this.listCostCenter = result.lsClaves;
        }
      }
    });
  }

  delete(id){
    let msg = '¿Esta seguro de querer eliminar a este centro de costos?'
    const dialogRef = this.dialog.open(ModalConfirmComponent, {
      minWidth: '50%',
      position: {
        top: '6%'
      },
      data: { type: 'delete', id: 13, button: 'Eliminar', title: 'Eliminar centro de costo', content: msg, icon: 'warning' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.requestDelete(id);
      }
    });
  }

  requestDelete(id) {
    let params= {IdClaveAutorizador: id};
    this.provService.deleteCenterCost(params, '123').then((res:any)=>{
      if(res){
        this.toastr.success('Centro de costos eliminado correctamente', '');
        this.getCostCenter();
      }else{
        this.toastr.error('No se pudo eliminar centro de costo, intetálo más tarde', 'Error');
      }
    }, (err) => {
      console.log(err);
      //this.listCostCenter = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
 }

}
